export function triggerFileDownload(url: string, fileName: string) {
  const a = document.createElement("a", {});
  a.setAttribute("href", url);
  a.setAttribute("download", fileName);
  a.setAttribute("name", fileName);
  a.setAttribute("class", "triggerFileDownloadLink");
  a.setAttribute("target", "_blank");
  const root = document.getElementById("root");
  document.body.insertBefore(a, root);
  a.click();
  return a;
}

export function triggerStringAsFileDownload(string: string, fileName: string, fileType = "text/tsv") {
  const bytes = new Uint8Array(string.length);
  for (let i = 0; i < string.length; i++) {
    bytes[i] = string.charCodeAt(i);
  }
  const blob = new Blob([bytes], {type: fileType});
  const url = window.URL.createObjectURL(blob);
  triggerFileDownload(url, fileName)
}

export function triggerMultiFileDownload(urls: string[]) {
  const a = document.createElement("a");
  urls.forEach(url => {
    a.setAttribute("href", url);
    a.setAttribute("target", "_blank");
    a.click();
  });
  document.removeChild(a);
}

export default triggerFileDownload;
